<script setup lang="ts">
import { ref, watch } from 'vue'
import { Dialog, DialogPanel } from '@headlessui/vue'
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
import { useAuth } from '../../composables/useAuth'

const props = defineProps<{
  show: boolean
  countdown: number
}>()

const emit = defineEmits(['stay', 'logout'])

const { handleLogout } = useAuth()
const formattedTime = ref('')

const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = seconds % 60
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`
}

watch(() => props.countdown, (newValue) => {
  formattedTime.value = formatTime(newValue)
}, { immediate: true })

const onLogout = async () => {
  emit('logout')
  await handleLogout()
}
</script>

<template>
  <Dialog 
    as="div" 
    class="relative z-[100]"
    :open="show"
    @close="$emit('stay')"
  >
    <div class="fixed inset-0 bg-black/30 backdrop-blur-sm" aria-hidden="true" />
    
    <div class="fixed inset-0 overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <DialogPanel class="mx-auto max-w-md w-full rounded-xl bg-white dark:bg-secondary-800 p-6 shadow-xl">
          <div class="flex items-start gap-4">
            <div class="flex-shrink-0">
              <ExclamationTriangleIcon class="h-6 w-6 text-yellow-500" />
            </div>
            <div class="flex-1">
              <h3 class="text-lg font-semibold text-secondary-900 dark:text-white mb-2">
                Cierre de sesión por inactividad
              </h3>
              <p class="text-secondary-600 dark:text-secondary-400 mb-1">
                Debido a inactividad, su sesión se cerrará automáticamente.
              </p>
              <p class="text-lg font-semibold text-primary-600 dark:text-primary-400 mb-4">
                Tiempo restante: {{ formattedTime }}
              </p>
              <div class="flex justify-end gap-3">
                <button
                  type="button"
                  class="btn-secondary"
                  @click="onLogout"
                >
                  Cerrar sesión
                </button>
                <button
                  type="button"
                  class="btn-primary"
                  @click="$emit('stay')"
                >
                  Mantener sesión
                </button>
              </div>
            </div>
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
</template>
